<div class="progress-wrapper" id="main-content">
    <ridango-page-content-wrapper>
        <ridango-progress-v2 [steps]="steps$ | async" [activeStep]="activeStep$ | async"> </ridango-progress-v2>
    </ridango-page-content-wrapper>
</div>

<div class="block--content block">
    <div class="block--wrap well well--collapsing container block">
        <rwidget-alert></rwidget-alert>
    </div>

    <div class="ticket">
        <ridango-page-content-wrapper>
            <div class="intro-text">
                <h1 class="title">{{ 'ADD_MONEY' | translate }}</h1>
                <p>
                    {{ 'ADD_MONEY_MANDATORY_TRAVEL_CARD' | translate }}
                </p>
                <p>
                    <span>
                        {{ 'ADD_MONEY_DESCRIPTION' | translate }}
                    </span>
                </p>
            </div>
            <ng-container
                *ngIf="
                    (loading$ | async) &&
                    (fixedSumProducts$ | async).length === 0 &&
                    (variableSumProduct$ | async) === false
                ">
                <ridango-ui-basic-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
                </ridango-ui-basic-loading-spinner>
            </ng-container>

            <ng-container
                *ngIf="
                    (loading$ | async) === false &&
                    (fixedSumProducts$ | async).length === 0 &&
                    (variableSumProduct$ | async) === false
                ">
                <ridango-block-full-width>
                    <h3>{{ 'NO_WALLET_PRODUCTS' | translate }}</h3>
                </ridango-block-full-width>
            </ng-container>

            <ng-container *ngIf="(fixedSumProducts$ | async).length > 0 || (variableSumProduct$ | async)">
                <rwidget-wallet-product-selector></rwidget-wallet-product-selector>
                <rwidget-purchase-medium></rwidget-purchase-medium>
                <ridango-arrow-down-separator></ridango-arrow-down-separator>
            </ng-container>
        </ridango-page-content-wrapper>
    </div>

    <div
        class="block--bg-wrapper ticket-summary"
        *ngIf="(fixedSumProducts$ | async).length > 0 || (variableSumProduct$ | async)">
        <h2 class="title-bg-wrapper">
            {{ 'TICKET_SUMMARY_AMOUNT_TITLE' | translate }}
        </h2>

        <ridango-page-content-wrapper>
            <rwidget-purchase-summary
                [flowCompleted]="isFlowCompleted$ | async"
                [locale]="locale"
                [tickets]="convertPayloadsToLocalTickets(payloads$ | async)"
                (postPayloads)="postToCart()">
            </rwidget-purchase-summary>
        </ridango-page-content-wrapper>
    </div>
</div>
